export default "__VITE_ASSET__BS$yi40f__"